import { render } from "./CardLoader.vue?vue&type=template&id=a0a244f6&scoped=true"
import script from "./CardLoader.vue?vue&type=script&lang=js"
export * from "./CardLoader.vue?vue&type=script&lang=js"

import "./CardLoader.vue?vue&type=style&index=0&id=a0a244f6&scoped=true&lang=css"

import exportComponent from "F:\\XAMPP_NEW\\htdocs\\ASRHAVELI\\delivery\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a244f6"]])

export default __exports__